<template>
  <article class="slds-card container">
    <div class="slds-card__header slds-grid">
      <header class="slds-media slds-media_center slds-has-flexi-truncate">
        <div class="slds-media__figure">
          <span class="slds-icon_container slds-icon-standard-campaign">
            <svg class="slds-icon slds-icon-action-announcement" aria-hidden="true">
              <use xlink:href="../assets/symbols.svg#campaign"></use>
            </svg>
          </span>
        </div>
        <div class="slds-media__body">
          <h2 class="slds-card__header-title">
            <span class="slds-card__header-link slds-truncate" :title="$t('sections.campaignDesigner')">
              {{ $t('sections.campaignDesigner') }}
            </span>
          </h2>
        </div>
        <div class="slds-no-flex">
          <button class="slds-button slds-button_icon slds-button_icon-border-filled" @click="toggleViewMode" >
            <svg class="slds-button__icon">
              <use xlink:href="../assets/symbols.svg#event" v-if="viewMode === 'list'"></use>
              <use xlink:href="../assets/symbols.svg#picklist_type" v-else></use>
            </svg>
          </button>
          <button class="slds-button slds-button_brand" @click="newCampaign" v-if="checkPermission('MANAGE_CAMPAIGN')">{{ $t('action.new') }}</button>
        </div>
      </header>
    </div>

    <div class="slds-card__body slds-card__body_inner" ref="calendarContainer">
      <CampaignsFilters
        class="filter-panel"
        v-model="filters"
        :search-key="searchKey"
        :tags="filters.tags"
        :type="filters.type"
        @changeSearchKey="searchKey = $event.value"
        @changeTags="filters.tags = $event.value"
        @changeType="filters.type = $event.value"
        @filterButtonClick="handleFilter" />

      <transition name="flip" mode="out-in">
        <CampaignsTable :campaigns="filteredCampaigns" @update="handleFilter" v-if="viewMode === 'list'"/>
        <CampaignsCalendar :campaigns="filteredCampaigns" @rendered="calculateSize" v-else />
      </transition>
    </div>

    <transition name="fade">
      <CampaignTypeSelector
        v-if="showCreateCampaignModal"
        @close="showCreateCampaignModal = false"
        @create="createCampaign" />
    </transition>
  </article>
</template>
<script>
import _ from 'lodash'
import CampaignTypeSelector from '../components/campaigns-list/CampaignTypeSelector'
import CampaignsCalendar from '../components/campaigns-list/CampaignsCalendar'
import CampaignsFilters from '../components/campaigns-list/CampaignsFilters'
import CampaignsTable from '../components/campaigns-list/CampaignsTable'
import CheckPermission from '../components/utils/CheckPermission'
import { applyFiltersToList } from '../components/utils/utils'
import moment from 'moment'

export default {
  mixins: [CheckPermission],
  components: {
    CampaignTypeSelector,
    CampaignsCalendar,
    CampaignsFilters,
    CampaignsTable
  },
  computed: {
    filtersForLocal () {
      const { tags, type } = this.filters
      return { tags, type, name: this.searchKey }
    },
    filtersForAPI () {
      const { startDate, endDate, status } = this.filters
      return { startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : '', endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : '', status }
    }
  },
  data () {
    return {
      availableCampaignTypes: ['full', 'head'],
      calendarHeight: 0,
      campaigns: [],
      loading: false,
      filteredCampaigns: [],
      filters: {
        endDate: '',
        startDate: '',
        status: ['Active', 'Draft', 'In Progress'],
        type: ''
      },
      searchKey: '',
      selectedCampaignType: '',
      showCreateCampaignModal: false,
      showDeleteModal: false,
      viewMode: 'list'
    }
  },
  methods: {
    applyFilters: _.debounce((list, searchKey, filtersObject, fieldsToFilter, callback) => applyFiltersToList(list, searchKey, filtersObject, fieldsToFilter, {}, callback), 300),
    calculateSize () {
      this.calendarHeight = this.$refs.calendarContainer.clientHeight
    },
    createCampaign (event) {
      const { type } = event
      this.$router.push(`/campaigns/new?type=${type}`)
    },
    doSearch: _.debounce(async (instance, callback) => instance.searchCampaigns(), 300),
    async handleFilter () {
      await this.doSearch(this)
      this.applyFilters(this.campaigns, this.searchKey, _.omit(this.filters, ['startDate', 'endDate', 'status']), ['id', 'name'], (filteredList) => this.filteredCampaigns = filteredList)
    },
    newCampaign () {
      this.showCreateCampaignModal = true
    },
    async searchCampaigns () {
      const campaigns = await this.$store.dispatch('campaignDesigner/getCampaigns', this.filtersForAPI)
      this.campaigns = campaigns
      this.applyFilters(campaigns, this.searchKey, _.omit(this.filters, ['startDate', 'endDate', 'status']), ['id', 'name'], (filteredList) => this.filteredCampaigns = filteredList)
    },
    toggleViewMode () {
      if (this.viewMode === 'list') {
        this.viewMode = 'calendar'
      } else if (this.viewMode === 'calendar') {
        this.viewMode = 'list'
      }
    }

  },
  async created () {
    try {
      // Clean store data
      await this.$store.dispatch('campaignDesigner/clearCampaignData')
      await this.handleFilter(this)
    } catch (error) {
      console.error(error)
      this.showToast('error', this.$t('general.error'), 'text', error.toJSON().message)
    }
  },
  watch: {
    filtersForLocal: {
      handler (value) {
        this.applyFilters(this.campaigns, this.searchKey, _.omit(this.filters, ['startDate', 'endDate', 'status']), ['id', 'name'], (filteredList) => { this.filteredCampaigns = filteredList; this.loading = false })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
}

.filter-panel {
  margin-bottom: 10px;
}
</style>
